'use client';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { USER } from 'src/auth/context/jwt';
import { OrganisationType } from 'src/types/dto/client.dto';

// ----------------------------------------------------------------------

export function useI18nReload() {
  const { i18n } = useTranslation();

  const reloadI18nConfig = useCallback(async () => {
    try {
      // Get current user data from localStorage
      const user = localStorage.getItem(USER);
      const { client } = JSON.parse(user || '{}');
      const type = client?.organisationType;

      // Clear existing resources to force reload
      await i18n.reloadResources();

      // Change language to trigger resource reload with new organization type
      const currentLang = i18n.language;
      await i18n.changeLanguage(currentLang);

      console.log('i18n configuration reloaded for organization type:', type);
    } catch (error) {
      console.error('Failed to reload i18n configuration:', error);
    }
  }, [i18n]);

  const reloadI18nForOrganizationType = useCallback(
    async (organizationType: OrganisationType) => {
      try {
        // Update localStorage with new organization type
        const user = localStorage.getItem(USER);
        const userData = JSON.parse(user || '{}');

        if (userData.client) {
          userData.client.organisationType = organizationType;
          localStorage.setItem(USER, JSON.stringify(userData));
        }

        // Reload i18n configuration
        await reloadI18nConfig();
      } catch (error) {
        console.error('Failed to reload i18n for organization type:', error);
      }
    },
    [reloadI18nConfig]
  );

  return {
    reloadI18nConfig,
    reloadI18nForOrganizationType,
  };
}
